"use client";
import Topbar from "./Topbar/Topbar";
import Navbar from "./Navbar/Navbar";

function Header() {
  return (
    <header className="sticky top-0 bg-ws-white-100 z-1000">
      <div>
        <Topbar />
      </div>

      <Navbar />
    </header>
  );
}

export default Header;
